import type { ReactFormGeneratorContextI } from '@ingenico/react-form-generator';
import { useDeviceManagementCapability } from '../../../hooks';

export function useExposedReactFormGeneratorProviderValue(): ReactFormGeneratorContextI {
  const shouldDisplayDeploymentsTab = useDeviceManagementCapability('configProfile.useDeploymentConfigurationFlow');

  return { isAbleToRenderTopHint: shouldDisplayDeploymentsTab };
}
